export const BEV_CONTACT = {
  firstName: 'Bev',
  lastName: '',
  phoneNumber: '(877) 378-0982',
  company: 'scribbl',
  title: 'myScribbl Assistant',
} as const

export const BEV_PHONE_DIGITS = BEV_CONTACT.phoneNumber.replace(/[^0-9]/g, '')
export const BEV_PHONE_LINK = `tel:+1${BEV_PHONE_DIGITS}`

export function downloadBevVcard() {
  const normalizedPhone = `+1${BEV_PHONE_DIGITS}`
  const fullName = `${BEV_CONTACT.firstName} ${BEV_CONTACT.lastName}`.trim()
  const vcard = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${BEV_CONTACT.lastName};${BEV_CONTACT.firstName};;;`,
    `FN:${fullName || BEV_CONTACT.firstName}`,
    `ORG:${BEV_CONTACT.company}`,
    `TITLE:${BEV_CONTACT.title}`,
    `TEL;TYPE=CELL:${normalizedPhone}`,
    'END:VCARD',
  ].join('\n')
  const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'bev.vcf'
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
